import { getAuth } from "firebase/auth";
import {
  child,
  get,
  getDatabase,
  onChildAdded,
  onValue,
  orderByKey,
  push,
  query,
  ref,
  remove,
  update,
} from "firebase/database";
import { now } from "moment";
import "../Firebase";

const auth = getAuth();

let db = getDatabase();
const dbRef = ref(getDatabase());
const coEditDocRef = ref(db, "coEditDoc");

export const createNewDoc = (data) => {
  return push(child(dbRef, "coEditDoc"), data).key;
};

export const updatecurrentPlanIndex = async (value) => {
  get(child(dbRef, `users/${auth.currentUser.uid}`)).then((snapshot) => {
    let user = snapshot.val();
    update(ref(db, `teams/${user.teamId}`), {
      curChapter: value,
    });
  });
};

export const updateCoEditDoc = async (id, content) => {
  await update(ref(db, `coEditDoc/${id}`), { textContent: content });
};

export const getCoEditDoc = async (chapter) => {
  let user = await get(child(dbRef, `users/${auth.currentUser.uid}`));
  let docIds = await get(child(dbRef, `teams/${user.val().teamId}/coEditDoc`));
  docIds = docIds.val();
  for (const doc_id in docIds) {
    let doc = docIds[doc_id];
    if (doc.chapter === chapter) {
      doc = await get(child(dbRef, `coEditDoc/${doc.docKey}`));
      doc = doc.val();
      return { docKey: doc.docKey, content: doc.textContent };
    }
  }

  return { docKey: null, content: "<p></p>" };
};
